import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ResolveEnd, Router } from '@angular/router';

import { CognitoUserPool } from 'amazon-cognito-identity-js';
import { filter } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../auth/auth.service';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {
    router.events
      .pipe(filter(event => event instanceof ResolveEnd))
      .subscribe((event) => {
        this.showLoginButton = this.authService.isLoggedIn();
      })
  }

  @Output()
  public sidenavToggle = new EventEmitter();
  @Input() showBackButton: boolean = false;
  @Input() currentTitle: string = "";
  @Input() showHistoryNav: boolean = false;

  showLoginButton: boolean = false;

  ngOnInit() {
    this.showLoginButton = this.authService.isLoggedIn();
  }

  onLogout(): void {
    let poolData = {
      UserPoolId: environment.cognitoUserPoolId,
      ClientId: environment.cognitoAppClientId
    };
    let userPool = new CognitoUserPool(poolData);
    let cognitoUser = userPool.getCurrentUser();
    cognitoUser?.signOut();
    this.router.navigate(["signin"])
  }

  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
}
}
